import { render, staticRenderFns } from "./life.vue?vue&type=template&id=0221b9f8&"
import script from "./life.vue?vue&type=script&lang=js&"
export * from "./life.vue?vue&type=script&lang=js&"
import style0 from "./life.vue?vue&type=style&index=0&id=0221b9f8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports